export default "__VITE_ASSET__bc1c231f__"